import { render, staticRenderFns } from "./CommunityWrapper.vue?vue&type=template&id=9a8b6e4a&scoped=true&"
import script from "./CommunityWrapper.vue?vue&type=script&lang=js&"
export * from "./CommunityWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8b6e4a",
  null
  
)

export default component.exports